import { DefaultPartnerLayout } from "@App/Layouts/Partner/DefaultPartnerLayout";
import { DefaultRoutes } from "@App/routes/Partner/DefaultRoutes";
import { Home } from "@App/Pages/Partner/Mara/Home";
import { useOrganizationConfig } from "@App/hooks/whitelabel/home/useOrganizationConfig";

export function Mara() {
  const { config } = useOrganizationConfig();

  return (
    <DefaultRoutes
      layout={
        <DefaultPartnerLayout
          logos={config.navbar.logos}
          backToPartnerButton={config.navbar.backToPartnerButton}
        />
      }
      home={<Home onSubmit={() => null} />}
    />
  );
}
